module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.9e083835.svg";